export type DATE_PATTERN =
  | "DATE"
  | "DATE_TIME"
  | "TIME"
  | "DAY"
  | "MONTH_YEAR"
  | "DAY_DATE"
  | "ISO_DATE";

export const LANDLORD_PROPERTY_TAX_LEGAL_DATE = new Date(new Date().getFullYear(), 7, 25);
